import React from 'react';

const Header = ({children, title}) => (
    <h1>{children || title}</h1>
);

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js